import { render, staticRenderFns } from "./IsThirdPartyInvolvedQuestion.vue?vue&type=template&id=0cf1d3bb&scoped=true"
import script from "./IsThirdPartyInvolvedQuestion.vue?vue&type=script&lang=ts"
export * from "./IsThirdPartyInvolvedQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1d3bb",
  null
  
)

export default component.exports